module.exports = __webpack_public_path__ + "img/The-Good-Gateway-Green-06.97cdb0c4.jpg";